import React, { useEffect, useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './components/HomePage';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import Services from './components/Services';
import PortfolioPage from './components/PortfolioPage';
import Strategy from './components/Strategy';

import FloatingWhatsApp from './components/FloatingWhatsApp';
import PoliticalWinsPage from './components/PoliticalWinsPage';

// Lazy load route components for better performance
import ClientOnboardingProcess from './components/ClientOnboardingProcess';
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));
const Disclaimer = lazy(() => import('./components/Disclaimer'));

// Loading component for lazy-loaded routes
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full mx-auto mb-4"></div>
      <p className="text-gray-600">Loading page...</p>
    </div>
  </div>
);


function App() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          {/* Scroll Progress Indicator */}
          <div
            className="fixed top-0 left-0 h-1 bg-gradient-to-r from-orange-500 via-white to-green-500 z-50 transition-all duration-300"
            style={{ width: `${scrollProgress}%` }}
          />

          {/* Floating WhatsApp Button */}
          <FloatingWhatsApp />

          {/* Header - Always visible */}
          <Header />

          {/* Main Content with Routing */}
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/strategy" element={<Strategy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/services" element={<Services />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/political-wins" element={<PoliticalWinsPage />} />
              <Route path="/client-onboarding" element={<ClientOnboardingProcess />} />
            </Routes>
          </Suspense>

          {/* Footer - Always visible */}
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
